import Vue from 'vue'
import App from './App.vue'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import router from './router'
import store from './store'
import './assets/style/common.less'
import './styles/index.less'
import * as echarts from 'echarts'
import 'echarts-extension-amap'
import initGlobalFilters from './utils/globel-filters'
import dataV from '@jiaminghi/data-view'

import dayjs from 'dayjs'
import './utils/rem'
import VueDeviceDetector from 'vue-device-detector'
var quarterOfYear = require('dayjs/plugin/quarterOfYear')
dayjs.extend(quarterOfYear)
Vue.prototype.dayjs = dayjs
Vue.prototype.$echarts = echarts
Vue.use(echarts)
Vue.use(dataV)

Vue.config.productionTip = false
Vue.use(ElementUI)
Vue.use(VueDeviceDetector)

initGlobalFilters(Vue)
function noon() {}

const whiteList = ['/index', '/404', '/401', '/login'] // 不重定向白名单
// 用户未操作30分钟自动退出至登录页面（30*60*1000毫秒）
const INACTIVITY_DURATION = 30 * 60 * 1000
let inactivityTimer = null // 全局单例定时器
const activityEvents = ['mousemove', 'keydown', 'click', 'scroll', 'touchstart']

// 抽离全局的无操作登出逻辑（避免Mixin重复绑定）
const inactivityHandler = {
  // 重置定时器
  resetTimer() {
    if (router.currentRoute.path === '/login') {
      this.clearTimer()
      return
    }
    this.clearTimer()
    inactivityTimer = setTimeout(() => {
      this.handleLogout()
    }, INACTIVITY_DURATION)
  },
  // 清除定时器
  clearTimer() {
    if (inactivityTimer) {
      clearTimeout(inactivityTimer)
      inactivityTimer = null
    }
  },
  // 处理登出逻辑
  handleLogout() {
    Vue.prototype.$message.warning('30分钟无操作，已自动退出登录')
    router.push({
      path: '/login',
      replace: true
    })
  },
  // 绑定活动事件
  bindEvents() {
    activityEvents.forEach(event => {
      document.addEventListener(event, this.resetTimer.bind(this))
    })
  },
  // 解绑活动事件
  unbindEvents() {
    activityEvents.forEach(event => {
      document.removeEventListener(event, this.resetTimer.bind(this))
    })
  }
}

// 初始化/切换路由时处理定时器
router.beforeEach((to, from, next) => {
  store.commit('globalVariable/setHistory', to.path)
  if (whiteList.includes(to.path)) {
    next()
    return null
  }
  if (!store.getters.user) {
    const params = {
      selfAreaId: store.getters.globaleSelfAreaId
    }
    // 用户数据拉取
    store.dispatch('user/getInfo', params).then(res => {
      store.commit('globalVariable/selfAddress', res.data && res.data.areaName)
      // 用户权限拉取
      store.dispatch('user/getPermission', params).then(() => noon)
      // 用户区域范围拉取
      const areaParams = {
        userAreaId: res.data.areaId,
        selfAreaId: store.getters.globaleSelfAreaId,
        areaId: store.getters.globaleSelfAreaId
      }
      store.dispatch('user/getUserArea2', areaParams).then(() => noon)
      const nationalParams = {
        selfAreaId: store.getters.globaleSelfAreaId
      }
      store.dispatch('globalVariable/getNationalArea', nationalParams).then(() => noon)
      next()
    }).catch(() => next())
  } else {
    next()
  }
})

// 路由变化时更新定时器状态
router.afterEach((to) => {
  if (to.path === '/login') {
    inactivityHandler.clearTimer()
    inactivityHandler.unbindEvents()
  } else {
    inactivityHandler.bindEvents()
    inactivityHandler.resetTimer()
  }
})

Vue.mixin({
  data() {
    return {
      permission: true
    }
  },
  methods: {
    // val 值，key 第一级，type，
    // 一级检验：checkUserAuth(4,'id',null)
    // 二级校验：checkUserAuth(6, 'id', 'child', 'id', 28)
    // 优化结果：一级检验：checkUserAuth(4,null)
    // 优化结果：二级检验：checkUserAuth(4,28)
    checkUserAuth(val, itemVal) {
      if (itemVal === 'show') {
        return true
      }
      const key = 'id'
      const towkey = 'child'
      const threekey = 'id'
      let permission = false
      const curr = (this.user && this.user.auth) || []
      if (!curr || !curr.length) {
        return permission
      }
      if (itemVal || itemVal === 0) {
        const res = curr.find(it => it[key] === val) && curr.find(it => it[key] === val)[towkey]
          ? curr.find(it => it[key] === val)[towkey].filter(it => it[threekey] === itemVal)
          : []
        if (res.length > 0) {
          permission = true
        }
      } else {
        const res = curr.filter(it => it[key] === val)
        if (res.length > 0) {
          permission = true
        }
      }
      return permission
    },
    // 获取设备信息方法（保留原有逻辑）
    getLoginDevice() {
      const device = this.$device
      let deviceName = ''
      if (device.android) {
        deviceName = 'Android设备'
      } else if (device.androidPhone) {
        deviceName = 'Android手机'
      } else if (device.dingding) {
        deviceName = '钉钉应用'
      } else if (device.iOS) {
        deviceName = 'iOS设备'
      } else if (device.ipad) {
        deviceName = 'iPad'
      } else if (device.iphone) {
        deviceName = 'iPhone'
      } else if (device.iphoneX) {
        deviceName = 'iPhoneX'
      } else if (device.ipod) {
        deviceName = 'iPod'
      } else if (device.mobile) {
        deviceName = '移动设备'
      } else if (device.wechat) {
        deviceName = '微信应用'
      } else if (device.wechatMiniApp) {
        deviceName = '微信小程序'
      } else {
        deviceName = 'Windows设备'
      }
      return deviceName
    }
  },
  created() {
    document.title = '义乌市共享电单车监管平台'
  }
})
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')

// 初始化：非登录页则绑定事件+启动定时器
if (router.currentRoute.path !== '/login') {
  inactivityHandler.bindEvents()
  inactivityHandler.resetTimer()
}

// 页面卸载时清理
window.addEventListener('beforeunload', () => {
  inactivityHandler.clearTimer()
  inactivityHandler.unbindEvents()
})
